import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Grid,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import { format as phoneFormat } from 'libphonenumber-js';

import Page from '../Page/Page';
// store
import UserStore from '../../stores/UserStore';
// components
import PaymentInfo from '../../components/Payment/PaymentInfo';
import EditUserInfoBtn from '../../components/Buttons/EditUserInfo';
import ChangePasswordBtn from '../../components/Buttons/ChangePassword';
import DeleteAccountButton from '../../components/Buttons/DeleteAccount';
import AddPaymentMethodButton from '../../components/Buttons/AddPaymentMethod';

import './Settings.css';

const Settings = observer(
class Settings extends Component {
  render() {
    const user = UserStore.user || {};

    return (
      <Page title="Settings">
        <div className="Settings-body">
          <Grid fluid>
            <Row className="Settings-row">
              <Col sm={3}>E-mail</Col>
              <Col sm={3}>{user.email}</Col>
            </Row>
            <Row className="Settings-row">
              <Col xs={9} sm={3}>Display name</Col>
              <Col xs={3} className="visible-xs"><EditUserInfoBtn /></Col>
              <Col xs={12} sm={7}>{user.name}</Col>
              <Col xsHidden sm={2}><EditUserInfoBtn /></Col>
            </Row>
            <Row className="Settings-row">
              <Col xs={9} sm={3}>Phone number</Col>
              <Col xs={3} className="visible-xs"><EditUserInfoBtn /></Col>
              <Col xs={12} sm={7}>{phoneFormat(user.phone, "US", "National")}</Col>
              <Col xsHidden sm={2}><EditUserInfoBtn /></Col>
            </Row>
            <Row className="Settings-row">
              <Col xs={9} sm={3}>Password</Col>
              <Col xs={3} className="visible-xs"><ChangePasswordBtn /></Col>
              <Col xs={12} sm={7}>*********</Col>
              <Col xsHidden sm={2}><ChangePasswordBtn /></Col>
            </Row>
            <Row className="Settings-row">
              <Col xs={9} sm={3}>Payment method</Col>
              <Col xs={3} className="visible-xs">{this.renderPaymentLinkBtn(user.hasPaymentMethod())}</Col>
              <Col xs={12} sm={7}>{this.renderPaymentMethod(user)}</Col>
              <Col xsHidden sm={2}>{this.renderPaymentLinkBtn(user.stripeSource)}</Col>
            </Row>
            <Row className="Settings-row">
              <Col xs={12}>
                <DeleteAccountButton />
              </Col>
            </Row>
          </Grid>
        </div>
      </Page>
    );
  }

  renderPaymentMethod = (user) => {
    return (user.hasPaymentMethod()) ? <PaymentInfo source={user.stripeSource} /> : <AddPaymentMethodButton />;
  }

  renderPaymentLinkBtn = (hasPaymentMethod) => {
    return hasPaymentMethod ? this.renderLinkBtn("Delete", UserStore.deletePaymentMethod) : null;
  }

  renderLinkBtn = (text = "Edit", onClick) => {
    const style = { color: (text === "Delete") ? "#d9534f": "" };
    return (
      <Button bsStyle="link" style={style} onClick={onClick}>{text}</Button>
    )
  }
});

export default Settings;


// WEBPACK FOOTER //
// ./src/pages/Settings/Settings.js